module.exports = __webpack_public_path__ + "static/media/left_leaf.d32861d2.png";